import React, { useRef } from 'react';
import { useHover } from 'react-native-web-hooks';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
const Container = styled.View`
  padding-horizontal: 16px;
  padding-vertical: 4px;
  background-color: ${_ref => {
  let {
    backgroundColor
  } = _ref;
  return backgroundColor;
}};
`;
export default function DropDownItem(_ref2) {
  let {
    item,
    selected
  } = _ref2;
  const ref = useRef(null);
  const hovered = useHover(ref);
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    backgroundColor: selected ? Colors.advanceBlue400 : hovered ? Colors.advanceBlue10 : Colors.white
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: selected ? Colors.white : hovered ? Colors.advanceBlue400 : Colors.gray600
  }, item.label));
}
DropDownItem.defaultProps = {
  item: {},
  selected: false
};
DropDownItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  selected: PropTypes.bool
};
//# sourceMappingURL=drop-down-item.js.map